require('../dataTransformers/clockTimeTransformer');

angular.module('app.shared.clockTimeUnit.clockTimeUnitDirective', [
  'app.shared.dataTransformers.clockTimeTransformer'
])
  .directive('clockTimeUnit', [
    '$filter',
    '$browser',
    'app.shared.dataTransformers.clockTimeTransformer',
    function ($filter, $browser, clockTimeTransformer) {
      "use strict";

      return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
          clockTime: '=?',
          unit: '@?'
        },
        link: ($scope, $el, $attrs, ngModelCtrl) => {
          let formatValue = () => {
            let value = ngModelCtrl.$viewValue;
            value = $filter('number')(value, 0);
            if (value > 60) {
              value = 60;
            }
            value = clockTimeTransformer.formatUnit(value);
            return value;
          };

          let listener = () => {
            $el.val(formatValue());
          };

          ngModelCtrl.$render = () => {
            listener();
          };

          $el.bind('change', listener);
          $el.bind('keydown', (event) => {
            let key = parseInt(event.keyCode);

            if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
            $browser.defer(listener);
          });
          $el.bind('paste cut', () => {
            $browser.defer(listener);
          })
        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/clockTimeUnit/clockTimeUnitDirective.js